import(/* webpackMode: "eager" */ "/app/apps/next/app/wv/[id]/page.tsx");
